import { Game } from "./Game";
import { Materials } from "./Materials";
import { GameConstants } from "./GameConstants";

export class GameVars {

    public static gameData: GameData;
    public static levelEdition: boolean = false;
    public static penalties: boolean;
    public static isShooterReady: boolean;
    public static paused: boolean;
    public static isBallAttachedToPassingMidfielder: boolean;
    public static scaleY: number;
    public static aspectRatio: number;
    public static fieldCorrectionScaleY: number;
    public static showDailyRewardScene: boolean;
    public static tournamentData: TournamentData;
    public static gameText: any;
    public static credits: number;
    public static teamsData: TeamData[];
    public static matchResult: string;
    public static playerID: number;
    public static adversaryID: number;
    public static matchType: string;
    public static playerGoals: number;
    public static showPreMatchLayer: boolean;
    public static timeOver: boolean;
    public static matchEnded: boolean;
    public static time: number;
    public static isTimedLevel: boolean;
    public static matchID: number;
    public static isGoalKeeperDuck: boolean;
    public static adversaryGoals: number;
    public static currentTournamentName: string;
    public static enteringLevelDirectly: boolean;
    public static voodooUsed: boolean;
    public static streakerFrequency: number;
    public static balls: number;
    public static ballsInField: number;
    public static matchJustUnlocked: boolean;
    public static tournamentJustUnlocked: boolean;
    public static penaltyScored: boolean;
    public static isBallAttachedToShootingPlayer: boolean;
    public static isBallAttachedToPlayer: boolean;
    public static goalKeeperType: string;
    public static justUnlockedTournamentName: string;


    // para el material de todos los pivotes
    public static originalAdversariesArray: Object[];
    public static tournamentDataArray: TournamentData[];
    
    private static _instance: GameVars = null;

    public firstTimePlayed: boolean;
    
    // materiales
    public materials: Materials;

    public static areValidDomains(domains: string[]): boolean {

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (window.location.hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (document.referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {
                if (document.referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static getLevelIndex(matchID: number): number {
        
        let ret = 0;
        
        let matchesData: MatchData[];
        
        for (let i = GameVars.tournamentDataArray.length - 1; i >= 0; i--) {
        
            matchesData = GameVars.tournamentDataArray[i].matchesData;
        
            for (let j = matchesData.length - 1; j >= 0; j--) {
        
                if (matchesData[j].id === matchID) {
        
                    ret = matchesData[j].index;
                    break;
                }
        
                if (ret) { 
                    break;
                }
            }
        }
        
        return ret;
    }

    public static getTournamentIndexFromTournamentName ( tournamentType: string ): number {

        let tournamentID = 0;

        switch (tournamentType) {
            case GameConstants.OCEANIA_CUP:
                tournamentID = 8;
                break;
            case GameConstants.AFRICA_CUP:
                tournamentID = 7;
                break;
            case GameConstants.ASIAN_CUP:
                tournamentID = 6;
                break;
            case GameConstants.GOLD_CUP:
                tournamentID = 5;
                break;
            case GameConstants.AMERICA_CUP:
                tournamentID = 4;
                break;
            case GameConstants.OLYMPIC_GAMES:
                tournamentID = 3;
                break;
            case GameConstants.EUROCUP:
                tournamentID = 2;
                break;
            case GameConstants.CONFEDERATIONS_CUP:
                tournamentID = 1;
                break;
            case GameConstants.WORLD_CUP:
                tournamentID = 0;
                break;
            default:
        }

        return tournamentID;
    }

    public static getCurrentTournamentName(): string {

        let ret = "";

        for (let i = 0; i < GameVars.gameData.tournamentData.length; i ++) {
            
            ret = GameVars.gameData.tournamentData[i].name;

            let matchesData = GameVars.gameData.tournamentData[i].matchesData;
            let stopIterating = false;
            for (let j = 0; j < matchesData.length; j ++) {
                if (!matchesData[i].locked) {
                    stopIterating = true;
                    break;
                }
            }

            if (stopIterating) {
                break;
            }
        }

        return ret;
    }

    public static getAchievedTrophies(): number {

        let ret = 0;

        for (let i = 0; i < GameVars.gameData.tournamentData.length; i ++) {
            
            if (GameVars.gameData.tournamentData[i].won) {
                ret ++;
            }   
        }

        return ret;
    }

    public static getTeamIDFromTeamName(teamName: string): number {

        let i = GameVars.teamsData .length - 1;

        while ( i > -1) {

            if (GameVars.teamsData [i].name === teamName) {
                return GameVars.teamsData [i].id;
            }

            i--;
        }
    }

    public static getPlayerData(): TeamData {

        return GameVars.teamsData[GameVars.playerID - 1];
    }

    public static getAdversaryData(): any {

        return GameVars.teamsData[GameVars.adversaryID - 1];
    }

    public static getLevelData(i: number): any {

        let levels: any = Game.currentInstance.cache.getJSON("levels");
        return levels[i];
    }

    public static getTournamentNameFromTournamentIndex(tournamentIndex: number): string {

        let tournamentName = GameConstants.OCEANIA_CUP;

        switch (tournamentIndex) {
            case 8:
                tournamentName = GameConstants.OCEANIA_CUP;
                break;
            case 7:
                tournamentName = GameConstants.AFRICA_CUP;
                break;
            case 6:
                tournamentName = GameConstants.ASIAN_CUP;
                break;
            case 5:
                tournamentName = GameConstants.GOLD_CUP;
                break;
            case 4:
                tournamentName = GameConstants.AMERICA_CUP;
                break;
            case 3:
                tournamentName = GameConstants.OLYMPIC_GAMES;
                break;
            case 2:
                tournamentName = GameConstants.EUROCUP;
                break;
            case 1:
                tournamentName = GameConstants.CONFEDERATIONS_CUP;
                break;
            case 0:
                tournamentName = GameConstants.WORLD_CUP;
                break;
            default:
        }

        return tournamentName;
    }

    public static getNextMatchIDFromCurrentMatchID(currentMatchId: number): number {

        let matchesData: MatchData[];
        
        const tournamentData = GameVars.gameData.tournamentData;

        for (let i = tournamentData.length - 1; i >= 0; i--) {

            matchesData = tournamentData[i].matchesData;

            for (let j = matchesData.length - 1; j >= 0; j--) {

                if (matchesData[j].id === currentMatchId) {

                    if (j > 0) {
                        return matchesData[j - 1].id;
                    } else if (i > 0) {
                        // mirar en el siguiente torneo el primer partido
                        const firstMatchNextTournamentIndex = tournamentData[i - 1].matchesData.length - 1;
                        return tournamentData[i - 1].matchesData[firstMatchNextTournamentIndex].id;
                    } else {
                        // se trata de la final
                        return -1;
                    }
                }
            }
        }
    }

    public static getMatchDataFromMatchID(matchID: number): MatchData {

        let ret: MatchData = null;

        for (let i = 0; i < GameVars.gameData.tournamentData.length; i++) {

            let matchesData = GameVars.gameData.tournamentData[i].matchesData;

            for (let j = 0; j < matchesData.length; j ++) {
                
                if (matchesData[j].id === matchID) {
                    ret = matchesData[j];
                    break;
                }
            }

            if (ret !== null) {
                break;
            }
        }

        return ret;
    }

    public static getMatchName(): string {

        let ret: string;

        switch (GameVars.matchType) {

            case GameConstants.FINAL_MATCH:
                ret = GameVars.gameText.FINAL;
                break;
            case GameConstants.SEMIFINAL_MATCH:
                ret = GameVars.gameText.SEMIFINAL;
                break;
            case GameConstants.QUARTERFINAL_MATCH:
                ret = GameVars.gameText.QUARTER;
                break;
            case GameConstants.ROUND_OF_16_MATCH:
                ret = GameVars.gameText.ROUND_OF_16;
                break;
            case GameConstants.GROUP_STAGE_MATCH:
                ret = GameVars.gameText.GROUP_STAGE;
                break;
            case GameConstants.QUALIFICATION:
                ret = GameVars.gameText.QUALIFICATION;
                break;
            default:
        }

        return ret;
    }

    public static getAchievedTrophy(): number {

        let trophyIndex = 0;
        
        for (let i = 0; i < GameVars.gameData.tournamentData.length; i++) {
            
            if (GameVars.gameData.tournamentData[i].won) {
                break;
            }

            trophyIndex ++;
        }
    
        return trophyIndex;
    }

    public static formatNumberForTextureAtlas (n: number): string {

        var s: string;

        if (n > 99) {
            s = "0" + n;
        } else if (n > 9) {
            s = "00" + n;
        } else {
            s = "000" + n;
        }

        return s;
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static getInstance(): GameVars {

        if (GameVars._instance === null) {
            GameVars._instance = new GameVars();
        }

        return GameVars._instance;
    }

    constructor() {

        if (GameVars._instance !== null) {
            throw new Error("Error: Instantiation failed: Use GameVars.getInstance() instead of new.");
        } else {
            GameVars._instance = this;
        }
    }

    public init(game: Phaser.Game): void {

        GameVars.showPreMatchLayer = true;

        if (GameConstants.DEVELOPMENT ) {
            this.initVarsWhileDeveloping();
        }
    }
    
    public createMaterials(): void {

        this.materials = new Materials(Game.currentInstance);
    }

    private initVarsWhileDeveloping(): void {

        GameVars.matchType = GameConstants.SEMIFINAL_MATCH;
        GameVars.ballsInField = 0;
        GameVars.playerGoals = 8;
        GameVars.adversaryGoals = 5;
        GameVars.matchResult = GameConstants.VICTORY;
        GameVars.matchID = 120;
        GameVars.playerID = 54;
        GameVars.adversaryID = 7;

        GameVars.showDailyRewardScene = true;
    }
}
